import React from 'react';

import Shimmer from 'components/Shimmer';

import { OptionTitle, OptionDetail } from '../BestOptions/styles';
import { Container, Option } from './styles';

interface Props {
  qty: number;
  hasFilters: boolean;
}

const LoadingFilter = ({ qty, hasFilters }: Props) => (
  <Container>
    {[...Array(qty).keys()].map((o, index) => (
      <React.Fragment key={index}>
        <Option active={true}>
          <OptionTitle active={false}>
            <Shimmer>Recomendado</Shimmer>
          </OptionTitle>
          {!hasFilters && (
            <>
              <OptionDetail highlight={false}>
                <Shimmer>$999.999 COP</Shimmer>
              </OptionDetail>
              <OptionDetail highlight={false}>
                <Shimmer>1h 00m</Shimmer>
              </OptionDetail>
            </>
          )}
        </Option>
      </React.Fragment>
    ))}
  </Container>
);

export default LoadingFilter;
